import { Link } from 'react-router-dom'
import { useClientConfig } from '@workspace/public-utils'
import BrandMark from '../BrandMark'
import useCompanyInfo from '../../hooks/useCompanyInfo'

export default function LottomdFooter() {
  const client = useClientConfig()
  const { data: company } = useCompanyInfo()
  const banks =
    company?.bank_infos?.filter(
      (bank, index, all) =>
        index === all.findIndex((item) => item.account_number === bank.account_number),
    ) ?? []
  return (
    <footer className="md-footer">
      {(banks.length > 0 || !!company?.extra_bottom_images?.length) && (
        <div className="md-payment-info">
          <div className="md-container">
            {banks.length > 0 && (
              <>
                <h2>무통장 입금 안내</h2>
                <div className="md-bank-list">
                  {banks.map((bank) => (
                    <div key={bank.account_number} className="md-bank">
                      {bank.bank_logo_url && (
                        <img
                          src={bank.bank_logo_url}
                          alt=""
                          width="36"
                          height="36"
                          loading="lazy"
                        />
                      )}
                      <div>
                        <strong>{bank.bank_name}</strong>
                        <p>{bank.account_number}</p>
                        <small>예금주: {bank.account_holder}</small>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
            {!!company?.extra_bottom_images?.length && (
              <div className="md-partners">
                {company.extra_bottom_images.map((src, index) => (
                  <img key={src} src={src} alt={`제휴 안내 ${index + 1}`} loading="lazy" />
                ))}
              </div>
            )}
          </div>
        </div>
      )}
      <div className="md-container">
        <div className="md-footer-main">
          <div>
            <div className="md-footer-brand">
              <span>한 주의 기대를 담는 곳,</span>
              <BrandMark />
            </div>
            <p className="md-footer-copy">
              좋은 기대는 챙기고,
              <br />
              일상의 여유는 지켜주세요.
            </p>
          </div>
          <nav className="md-footer-links" aria-label="하단 메뉴">
            <Link to="/dashboard/numbers">내 번호함</Link>
            <Link to="/plans">구독 안내</Link>
            <Link to="/faq">이용 안내</Link>
            <Link to="/terms">이용약관</Link>
            <Link to="/privacy">개인정보처리방침</Link>
          </nav>
        </div>
        {(company?.contact_number ||
          company?.contact_number_secondary ||
          company?.contact_email ||
          company?.working_hours ||
          company?.address) && (
          <address className="md-footer-contact">
            {company.contact_number && (
              <a href={`tel:${company.contact_number.replace(/[^0-9+]/g, '')}`}>
                대표 전화 {company.contact_number}
              </a>
            )}
            {company.contact_number_secondary && (
              <a href={`tel:${company.contact_number_secondary.replace(/[^0-9+]/g, '')}`}>
                고객센터 {company.contact_number_secondary}
              </a>
            )}
            {company.contact_email && (
              <a href={`mailto:${company.contact_email}`}>{company.contact_email}</a>
            )}
            {company.working_hours && <span>상담 시간 {company.working_hours}</span>}
            {company.address && <span>{company.address}</span>}
          </address>
        )}
        <div className="md-footer-bottom">
          <div>
            <p>
              © {new Date().getFullYear()} {company?.name || client.copyrightFallback}
            </p>
            {company?.owner && <p>대표자: {company.owner}</p>}
            {company?.business_registration_number && (
              <p>사업자번호: {company.business_registration_number}</p>
            )}
            {company?.ecommerce_registration_number && (
              <p>통신판매신고번호: {company.ecommerce_registration_number}</p>
            )}
          </div>
          <p>본 서비스는 만 19세 이상만 이용 가능합니다.</p>
        </div>
      </div>
    </footer>
  )
}
